import { QueryList } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';

export function matTooltipSetter(queryList: QueryList<MatTooltip>): void {
  queryList.toArray().forEach((tooltip) => {
    // Magic string - private member
    delete tooltip['_viewContainerRef'];
  });
}
